import {GameStateEnums} from '../../../../../shared/GameEnums'
import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIGameCityImprovementProgressTrackerView} from './UIGameCityImprovementProgressTrackerView'
import {UIGameMechanic} from '../UIGameEventController'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {CityImprovementTypes, MechanicCityImprovementsState, PlayerColor} from '@colonist/game-states'
import {MechanicValidatorCityImprovements} from '@colonist/game-mechanic-validators'

export class UIGamePlayerInformationCityImprovementProgressTrackerView extends SectionView implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly cityImprovementProgressTrackerViews: UIGameCityImprovementProgressTrackerView[]
    private readonly playerColor: PlayerColor
    private readonly cityImprovementsState: MechanicCityImprovementsState
    private readonly cityImprovementsValidator: MechanicValidatorCityImprovements

    constructor(uiGameManager: UIGameManager, cityImprovementsState: MechanicCityImprovementsState, playerColor: PlayerColor, x: number, y: number, w: number, h: number, container: PIXI.Container) {
        const removePadding = true
        super(x, y, w, h, container, removePadding)
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.cityImprovementsState = cityImprovementsState
        this.cityImprovementsValidator = new MechanicValidatorCityImprovements(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, this.cityImprovementsState)
        this.playerColor = playerColor

        this.cityImprovementProgressTrackerViews = []
        this.initCityImprovementProgressTrackerViews()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CityImprovementStateUpdated: this.updateCityProgressTracker(); break
            default: break
        }
    }

    private initCityImprovementProgressTrackerViews() {
        const squareWidth = this.width / 3
        this.cityImprovementProgressTrackerViews.push(new UIGameCityImprovementProgressTrackerView(0, 0, squareWidth, this, CityImprovementTypes.Science))
        this.cityImprovementProgressTrackerViews.push(new UIGameCityImprovementProgressTrackerView(squareWidth, 0, squareWidth, this, CityImprovementTypes.Trade))
        this.cityImprovementProgressTrackerViews.push(new UIGameCityImprovementProgressTrackerView(squareWidth * 2, 0, squareWidth, this, CityImprovementTypes.Politics))
        this.updateCityProgressTracker()
    }

    private updateCityProgressTracker() {
        for(const cityImprovementProgressTrackerView of this.cityImprovementProgressTrackerViews) {
            const cityImprovementState = this.cityImprovementsValidator.getPlayerCityImprovementsStateForType(this.playerColor, cityImprovementProgressTrackerView.cityImprovementType)
            if(cityImprovementState == undefined) continue

            cityImprovementState.hasMetropolis ? cityImprovementProgressTrackerView.showMetropolisIcon() : cityImprovementProgressTrackerView.hideMetropolisIcon()
            const previousCityLevel = cityImprovementProgressTrackerView.currentCityImprovementLevel
            const currentCityLevel = cityImprovementState.level

            if(previousCityLevel == currentCityLevel) continue
            cityImprovementProgressTrackerView.updateProgressTracker(cityImprovementState.level)
        }
    }

    destroy() {
        super.destroy()

        this.uiGameManager.eventController.unregisterUIGameMechanic(this)
    }
}
